module.exports = __webpack_public_path__ + "static/media/giphy-10.77308c0e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-10.gif
// module id = 181
// module chunks = 0